 import { useState, useEffect } from "react";
import HiTrustLogo from "../../assets/images/HITRUSTCSFCertifiedLogo_white.png";
import PoweredByAWS from "../../assets/images/poweredby-aws.png";
import { getDomainFromUrl } from "../../utils/domainUtilities";
import Copyright from "./Copyright";

const Footer = () => {
  const [domainFooter, setDomainFooter] = useState(null);

  useEffect(() => {
    const initializeFooter = async () => {
      try {
        const customFooter = await import(
          "../../custom_portal/" + getDomainFromUrl(window.location.hostname) + "/components/shared/Footer"
        );

        setDomainFooter(customFooter.default());
      } catch (error) {
        setDomainFooter(DefaultBox);
      }
    };

    initializeFooter();
  }, []);

  const DefaultBox = (
    <div className="ses_footer">
      <div className="ses-footer animate slide delay-2">
        <footer role="contentinfo">
          <div className="ses-footer-container">
            <div className="ses-directTrust" role="img" aria-label="Direct Trust Certification: DTAAP HISP DTAAP CA DTAAP RA" ></div>
          </div>
          <div className="right-container">
            <div className="poweredby-aws">
              <a href="http://hitrustalliance.net" target="_blank" rel="noreferrer" >
                <img src={HiTrustLogo} className="hitrust-img" alt="HITRUST CSF Certified" />
                <span className="sr-only">(opens in a new tab)</span>
              </a>
              <img src={PoweredByAWS} alt="Powered by AWS" />
            </div>
            <div className="contact-footer">
              <strong>Technical Support:</strong> {" "}
              <a href="tel:18884709913" aria-label="Call technical support at 1-888-470-9913">
                1.888.470.9913
              </a>{" "} | {" "}<a href="mailto:support@secureexsolutions.com" aria-label="Email technical support at support@secureexsolutions.com"> support@secureexsolutions.com </a>
            </div>
            <Copyright />
          </div>
        </footer>
      </div>
    </div>
  );
  return <div>{domainFooter}</div>;
};

export default Footer;
